// extracted by mini-css-extract-plugin
module.exports = {"download-btn":"CustomImage_download-btn__Earpm"};